<portal-page [showBackground]="true" design="col2">
  <section class="bg-light-gray" col1 aria-labelledby="headereLogin">
    <portal-login-form />
  </section>

  <section class="bg-white" col2 aria-labelledby="headerSignup">
    <div class="svg-image">
      <portal-erfolg-1-svg />
    </div>
    @if (isPasswordGrantAvailable) {
      <h2 class="mat-h4" id="headerSignup">{{ 'title.signup' | translate }}</h2>
      <p class="translation-text">{{ 'text.signup' | translate }}</p>
      <button class="align-self-stretch align-self-sm-start" mat-flat-button color="primary" routerLink="/registrieren">
        {{ 'title.signup' | translate }}
      </button>
    }
  </section>
</portal-page>
